import { formatPriceAmount } from "../../../utils/saleUtils";
import { Modal, Form, Button } from "react-bootstrap";
import apiClient from "../../../api/apiClient";
import { handleErrors } from "../../../modules/handleErrors";
import { toast } from "react-toastify";
import React, { useState } from "react";

export const BatchPriceModal = ({
  show,
  onHide,
  selectedIds,
  selectedBundleIds = [],
  isSelectedAll = false,
  mockupsCount = 0,
  onSuccess,
}) => {
  const [price, setPrice] = useState("");
  const [loading, setLoading] = useState(false);

  const listingCount = isSelectedAll ? mockupsCount : selectedIds.length;
  const bundleCount = selectedBundleIds.length;
  const selectedCount = listingCount + bundleCount;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const num = parseFloat(price);
    if (isNaN(num) || num < 0) {
      toast.error("Enter a valid price (0 or greater).");
      return;
    }
    if (!isSelectedAll && selectedIds.length === 0 && selectedBundleIds.length === 0) {
      toast.error("No items selected.");
      return;
    }

    setLoading(true);
    try {
      const body = {
        price: String(num),
        ...(isSelectedAll ? { isSelectedAll: true } : { ids: selectedIds.map((id) => String(id)) }),
        ...(selectedBundleIds.length > 0 ? { bundle_ids: selectedBundleIds.map((id) => String(id)) } : {}),
      };

      const res = await apiClient.post("/listings/change/batch_price/", body);

      if (!res.ok) {
        handleErrors(res.data);
        setLoading(false);
        return;
      }

      const parts = [];
      if (listingCount > 0) parts.push(`${listingCount} mockup${listingCount === 1 ? "" : "s"}`);
      if (bundleCount > 0) parts.push(`${bundleCount} bundle${bundleCount === 1 ? "" : "s"}`);
      toast.success(
        `Price updated to ${formatPriceAmount(num)} for ${parts.join(" and ")}.`
      );
      setPrice("");
      onSuccess();
      onHide();
    } catch (err) {
      toast.error("Failed to update prices.");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setPrice("");
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Batch price change</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small mb-3">
          Set a new price for all selected items ({selectedCount}{" "}
          selected).
        </p>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>New price (USD)</Form.Label>
            <Form.Control
              type="number"
              min="0"
              step="0.01"
              placeholder="0.00"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              disabled={loading}
            />
          </Form.Group>
          <div className="d-flex gap-2 justify-content-end">
            <Button variant="secondary" onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
            <Button
              type="submit"
              className="red-btn"
              disabled={loading || price === ""}
            >
              {loading ? "Updating…" : "Apply to selected"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
